<template>
  <v-content class="pa-0">
    <v-row justify="space-around">
          
        <v-snackbar v-model="snackbar" :timeout="4000" :color="color" > {{text}}
          <v-btn color="white" text @click="snackbar = false" > Cerrar  </v-btn>
        </v-snackbar>

        <v-col cols="12" md="8" lg="6" xl="5">
          <v-card flat transparent>

            <v-col cols="12">
              <v-toolbar color="primary" dark>
                <v-toolbar-title > Registrarse </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn  text color="white" x-small fab dark :to="{name: 'Login'}"><v-icon>reply</v-icon></v-btn>
              </v-toolbar>
            </v-col>

            <v-col cols="12" v-if="correoEnviado">
              <v-alert dense text type="success" icon="email"  dismissible border="left" colored-border>
                Hemos <strong> envíado </strong> 
                un    <strong> correo  </strong> de validación de usuario a tu 
                      <strong> cuenta. </strong>
              
              </v-alert>
            </v-col>

            <v-card-text class="mt-2" align="center">
              <img src="https://support-smipack.com/fotos/logo.png"  height="100%" class="mb-5" >
                <v-form ref="form" v-model="valid" >
                  <v-row>
                    <v-col cols="12" sm="6"> 
                      <v-row> 
                        <v-col cols="12">
                          <v-text-field 
                            v-model="nombre" 
                            color="secondary"
                            clearable
                            hide-details 
                            prepend-icon="person" 
                            label="Nombre de usuario" 
                            outlined dense 
                            :rules="nombreRules"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field 
                            v-model="apellidos" 
                            color="secondary"
                            clearable
                            hide-details 
                            prepend-icon="person" 
                            label="apellidos" 
                            outlined dense 
                            :rules="apellidosRules"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field 
                            v-model.number="telmovil" 
                            color="secondary"
                            clearable
                            hide-details 
                            prepend-icon="phone" 
                            label="Telefono celular" 
                            outlined dense 
                            :rules="telmovilRules"
                            type="number"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field 
                            v-model="email" 
                            color="secondary"
                            clearable
                            hide-details 
                            prepend-icon="email" 
                            label="Correo" 
                            outlined dense 
                            :rules="emailRules"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field
                            v-model="password"
                            prepend-icon="lock"
                            :append-icon="show1 ? 'visibility' : 'visibility_off'"
                            :rules="rulesPassword"
                            :type="show1 ? 'text' : 'password'"
                            label="Contraseña"
                            counter
                            @click:append="show1 = !show1"
                            dense
                            
                            outlined
                            color="secondary"
                            clearable
                            hide-details
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field
                            v-model="password2"
                            prepend-icon="lock"
                            :append-icon="show2 ? 'visibility_off' : 'visibility'"
                            :rules="rulesPassword2"
                            :type="show2 ? 'text' : 'password'"
                            label="Confirma la contraseña"
                            @click:append="show2 = !show2"
                            outlined
                            color="secondary"
                            clearable
                            hide-details
                            dense
                            
                          ></v-text-field>
                        </v-col>

                      </v-row>
                    </v-col>
                    <v-col cols="12" sm="6"> 
                      <v-row>
                        <v-col cols="12">
                          <v-text-field 
                            v-model="empresa" 
                            prepend-icon="domain" 
                            label="Empresa" 
                            outlined dense 
                            :rules="empresaRules"
                            color="secondary"
                            clearable
                            hide-details
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field 
                            v-model.number="telempresa" 
                            prepend-icon="contact_phone" 
                            label="Telefono de empresa" 
                            outlined dense 
                            :rules="telempresaRules"
                            type="number"
                            color="secondary"
                            clearable
                            hide-details
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field 
                            v-model="modmaquina" 
                            prepend-icon="account_balance_wallet" 
                            label="Modelo de la maquina" 
                            outlined dense 
                            :rules="modmaquinaRules"
                            color="secondary"
                            clearable
                            hide-details
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field 
                            v-model="matserie" 
                            prepend-icon="format_list_numbered_rtl" 
                            label="Matricula/Serie" 
                            outlined dense 
                            :rules="matserieRules"
                            color="secondary"
                            clearable
                            hide-details
                            ></v-text-field>
                        </v-col>

                        <v-col cols="12">
                          <v-img src="@/assets/ayuda.jpeg" contain @click="dialog= true"/>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-form>
              <v-card-actions> <v-spacer></v-spacer>
                <v-btn  small color="primary" @click="ayuda = true">Soporte <v-icon right>contact_support</v-icon></v-btn>
                <v-btn :disabled="!valid" small color="secondary" @click="validarExistencia()">Registrarme</v-btn>
              </v-card-actions>
            </v-card-text>
          </v-card>
        </v-col> 
      </v-row>

      <v-dialog
        v-model="dialog"
        scrollable 
        :overlay="false"
        max-width="500px"
        transition="dialog-transition"
      >
        <v-img src="@/assets/ayuda.jpeg" contain/>
      </v-dialog>

      <v-dialog
        v-model="ayuda"
        max-width="290"
        >
        <v-card>
          <v-card-title class="headline">SOPORTE SMIPACK</v-card-title>

          <v-divider></v-divider>

          <div class="mx-6">
            Comunícate con nosotros a través de las siguientes opciones
          </div>

          <br/>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" href="mailto:aclientes@mikai.com.mx" fab><v-icon>email</v-icon></v-btn>
            <v-spacer></v-spacer>  
            <v-btn color="primary" href="https://api.whatsapp.com/send?phone=528141641814&text=" target="_blank" fab><v-icon>mdi-whatsapp</v-icon></v-btn>
            <v-spacer></v-spacer>  
          </v-card-actions>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              color="green darken-1"
              text
              @click="ayuda = false"
            >
              Cancelar
            </v-btn>

          </v-card-actions>
        </v-card>
      </v-dialog>
  </v-content>
</template>

<script>
// import axios from 'axios'
import {mapActions} from 'vuex'

export default {
  data(){
    return{
      dialog: false,
      ayuda: false,
      // PASSWORD
      valid: true,
      show1: true,
      show2: true,
      correoEnviado: false,
      password:'',
      password2:'',
      rulesPassword: [
          v => !!v || 'Requerido.',
          v => v.length >= 8 || 'Minímo 8 caracteres',
        ],
      rulesPassword2: [
        v => !!v || 'Requerido.',
        v => v.length >= 8 || 'Minímo 8 caracteres',
        v => v == this.password || 'Las contraseñas no coinciden',
      ],
      // VARIABLES
      nombre:'',
      nombreRules: [v => !!v || 'Es requerido'],
      apellidos:'',
      apellidosRules: [v => !!v || 'Es requerido'],
      telmovil:'',
      telmovilRules: [v => !!v || 'Es requerido'],
      email:'',
      emailRules: [v => !!v || 'Es requerido', v => /.+@.+\..+/.test(v) || 'E-mail no es valido'],
      empresa:'',
      empresaRules: [v => !!v || 'Es requerido'],
      telempresa:'',
      telempresaRules: [v => !!v || 'Es requerido'],
      modmaquina:'',
      modmaquinaRules: [v => !!v || 'Es requerido'],
      matserie:'',
      matserieRules: [v => !!v || 'Es requerido'],

      error:'',
      ID: '',
      
      // SNACKBAR
      snackbar: false,
      color : 'red darken-4',
      text:'',
      logo:'',
       
    }
  },

  created(){
  },

  methods:{
      
      validarExistencia(){
        var md5 = require('md5');
        var usuario = {
          nombre    : this.nombre, 
          apellidos : this.apellidos,
          empresa   : this.empresa,
          telempresa: this.telempresa,
          telmovil  : this.telmovil,
          email     : this.email, 
          modmaquina: this.modmaquina,
          matserie  : this.matserie,
          password  : md5(this.password),
          nivel     : 'USUARIO',
          estatus   : 0
        }
      
       console.log('usuario', usuario)
        
        this.$http.post('registro', usuario).then(response=>{
          if(!response.body.message){
            this.enviarCorreo(response.body)
          }else{
            this.snackbar=true; this.text=response.body.message;// SI EL USUARIO YA EXISTE MUESTRO MENSAJE
          }
        }).catch(err =>{ console.log('error', error) })
      },

      enviarCorreo(req){
        var url = 'https://support-smipack.com/#/activarusuario/'
        var payload = {
          nombre:       req.nombre,
          correo:       req.email,
          url:          url + req.id
        }

        this.$http.post('correos.send',  payload).then(respuesta=>{ 
          this.text = 'Hemos envíado un correo de validación de usuario a tu cuenta.'
          this.color = 'green darken-4'
          this.snackbar = true;
          this.correoEnviado = true;
        }).catch(error=>{
          console.log('error',error)
          resolve(false)
        })
      },

    }
}
</script>
<!-- 
<style type="text/css" media="screen">
A:link {text-decoration: none }
A:hover { color: black; font-family: arial; text-decoration: none }
A:visited {color: black;  font-family: arial; text-decoration: none }
  *{outline:none !important;}*:focus {outline: none !important;}textarea:focus, input:focus{outline: none !important;}  a{text-decoration: none !important;outline: none !important;}
</style> -->